import { Card, Divider, Typography } from '@mui/material';
import { useEffect } from 'react';
import { detractors, promoters } from '../constants/constants';
import { useBarChart } from '../hooks/useBarChart';
import { Loader } from './Loader';
import { AppBarChart } from './charts/BarChart';

const MonthwiseFeedbackChart = ({ data }) => {
  const { graphData, loading, setGraphData, setLoading, setYAxis, yAxis } =
    useBarChart();

  function calculateMonthlyNPS(responses) {
    const monthlyNPS = {};

    for (const response of responses) {
      const date = new Date(response?.createdDate);
      const key = `${date.getFullYear()}-${date.getMonth()}`; // e.g., "2024-3"

      if (response.feedback) {
        if (!monthlyNPS[key]) {
          monthlyNPS[key] = {
            promoters: 0,
            detractors: 0,
            total: 0,
            date, // Save actual date for sorting
          };
        }

        if (promoters.includes(response.feedback)) {
          monthlyNPS[key].promoters++;
        } else if (detractors.includes(response.feedback)) {
          monthlyNPS[key].detractors++;
        }

        monthlyNPS[key].total++;
      }
    }

    const monthWiseNPSArr = Object.values(monthlyNPS)
      .map(({ promoters, detractors, total, date }) => {
        const nps = (((promoters - detractors) / total) * 100).toFixed(0);
        const month = date.toLocaleString('en-US', {
          month: 'short',
          year: 'numeric',
        });
        return { month, nps: Number(nps), date };
      })
      .sort((a, b) => a.date - b.date); // Sort chronologically
      
    const values = monthWiseNPSArr.map((item) => Number(item.nps));
    setYAxis({ min: Math.min(...values), max: Math.max(...values) });

    return monthWiseNPSArr;
  }

  useEffect(() => {
    if (data) {
      setGraphData(calculateMonthlyNPS(data));
      setLoading(false);
    }
  }, [data]);

  return (
    <Card
      variant="outlined"
      sx={{
        boxShadow: 3,
        width: '100%',
        height: '320px',
        p: '15px',
        background: '#1d2637',
        color: 'white',
        borderRadius: '12px',
        fontFamily: 'Montserrat, serif !important',
      }}
    >
      <Typography
        sx={{ fontFamily: 'Montserrat, serif !important' }}
        variant="overline"
        gutterBottom
      >
        Month-wise NPS
      </Typography>
      <Divider />
      {loading ? (
        <Loader />
      ) : (
        <AppBarChart
          data={graphData}
          xAxisKey={'month'}
          xLabel={'Month'}
          yLabel={'NPS Score'}
          dataKey={'nps'}
          yMax={yAxis.max}
          yMin={yAxis.min}
          fill="#7E22CD"
          yMaxOffset={0}
          yMinOffset={0}
        />
      )}
    </Card>
  );
};

export default MonthwiseFeedbackChart;
